import { render } from "./SelectName.vue?vue&type=template&id=97172274&scoped=true"
import script from "./SelectName.vue?vue&type=script&lang=js"
export * from "./SelectName.vue?vue&type=script&lang=js"

import "./SelectName.vue?vue&type=style&index=0&id=97172274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97172274"]])

export default __exports__